import React, {useRef, useState} from 'react'
import {TimesheetTableBody} from "./TimesheetTableBody";
import {TimesheetTableHeader} from "./TimesheetTableHeader";

interface ITimesheetTableProps {
    itemToEdit: any
}

export const TimesheetTable: React.FC<ITimesheetTableProps> = ({itemToEdit}) => {

    const [filterByProjectName, setFilterByProjectName] = useState("")
    const [filterByProjectDescription, setFilterByProjectDescription] = useState("")
    const [sortByDate, setSortByDate] = useState("ASC")
    const [sortByTotal, setSortByTotal] = useState("")
    const [selectedCategory, setSelectedCategory] = useState<{label: string, value: string} | null>(null);

    const bodyScrollRef = useRef<HTMLDivElement>(null);
    const headScrollRef = useRef<HTMLDivElement>(null);

    const handleBodyScroll = () => {
        if (bodyScrollRef.current && headScrollRef.current) {
            headScrollRef.current.scrollLeft = bodyScrollRef.current.scrollLeft;
        }
    };

    return (
        <div className="section-table__main table-timesheet">
            {/* Sticky column header outside the overflow-x container */}
            <div ref={headScrollRef} className="section-table__head-sticky-wrap">
                <div className="section-table__main--wrapper">
                    <TimesheetTableHeader
                        setFilterByProjectName={setFilterByProjectName}
                        setFilterByProjectDescription={setFilterByProjectDescription}
                        setSortByDate={setSortByDate}
                        setSortByTotal={setSortByTotal}
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                    />
                </div>
            </div>
            {/* Scrollable body - horizontal scroll only */}
            <div ref={bodyScrollRef} className="section-table__main--container" onScroll={handleBodyScroll}>
                <div className="section-table__main--wrapper">
                    <TimesheetTableBody
                        filterByProjectName={filterByProjectName}
                        filterByProjectDescription={filterByProjectDescription}
                        sortByDate={sortByDate}
                        sortByTotal={sortByTotal}
                        itemToEdit={itemToEdit}
                        selectedCategory={selectedCategory}
                    />
                </div>
            </div>
        </div>
    )
}
